<template>
  <div class="wrapper">
    <div class="page-header page-header-large">
      <parallax
        class="page-header-image"
        style="background-image: url('img/open-platform/service_main.png')"
      ></parallax>

      <!-- platform-connected-cars.png -->

      <div class="content-center">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto">
            <h4 class="title">Our Location</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <img class="img" alt="Raised Image" src="img/aboutus/dasan_building.jpg" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <!--
            <h8 class="description">
              AiCAR is a market leader in auto-tech innovation and has aggregated differentiated services for the connected car. We focus on services that save users time and money, as well as prioritising their safety. Our flexible technology allows users to freely change their vehicles, as well as select their preferred service providers.
            </h8>
            -->

            <p class="description mb-5 text-center">
              {{ $t('PresentationSection6ContentText1') }}
              <br />
              {{ $t('PresentationSection6ContentText2') }}
            </p>
          </div>
        </div>

        <!-- 
        <div class="row">
          <div class="col-md-12">
            <img class="img" alt="Raised Image" src="img/aboutus/Location_Detroit.jpg" />
          </div>
        </div>
        -->
      </div>
    </div>

    <!-- 
    <div class="about-office" style="padding-bottom: 10px;">
      <div class="container">

        <div class="row text-center">
          <div class="col-md-12 ml-auto mr-auto">
            <h2 class="title">Our Location</h2>
          </div>

          <div class="col-md-8 ml-auto mr-auto">
            <img class="img" alt src="img/aboutus/Location_Detroit.jpg" />
          </div>

          <div class="col-md-8 ml-auto mr-auto">
            <p class="description mb-5 text-center">
              {{ $t('PresentationSection6ContentText1') }}
              <br />

              {{ $t('PresentationSection6ContentText2') }}
            </p>
          </div>

        </div>

      </div>
    </div>
    -->
  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from "@/components";
import { Select, Option } from "element-ui";

export default {
  name: "about-us",
  bodyClass: "about-us",
  components: {
    Card,
    InfoSection,
    Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: ""
      }
    };
  }
};
</script>
<style>
</style>
